import React, { useState } from 'react';
import { sendSlidesAsPdf, updateAnalytics, stopEventStreamUpdates } from '@services';
import { NavButton } from './styles';
import { useMutation } from 'react-query';
import { ANALYTICS_EVENTS, TOAST_TYPES } from '@constants';
import { usePresentation } from '@context/presentation';
import { endPresentation } from '@utils/browserStorage';
import { toastNotification } from '@utils/toast';
import { getErrorMessage } from '@utils/errorHandling';
import { createAnalyticsEventBody } from '@utils/analytics';

export const SendSlidePdfButton = ({ dispatch, selectedTerms, slideId }) => {
    const { client, presentationType, presentationId } = usePresentation();
    const { language } = client;
    const { error, success } = TOAST_TYPES;
    const [sendingPdf, setSendingPdf] = useState(false);
    
    const sendPdf = useMutation(data => sendSlidesAsPdf(data), {
        onSuccess: async () => {
            const { pdfSent } = ANALYTICS_EVENTS;

            createAnalyticsEventBody(presentationId, pdfSent)
            await updateAnalytics(createAnalyticsEventBody(presentationId, pdfSent));

            toastNotification(success, 'Pdf sent!');
            setSendingPdf(false);
            endPresentation(dispatch);

            await stopEventStreamUpdates({ presentationType, slideId, presentationId });
        },
        onError: err => {
            setSendingPdf(false);
            toastNotification(error, `Unable to send pdf: ${getErrorMessage(err)}`, {
                autoClose: 3000,
                hideProgressBar: false
            });
        }
    });

    const handleClick = () => {
        setSendingPdf(true);

        const keyword = language === 'English' ? 'Analysis' : 'Análisis';
        
        sendPdf.mutate({ keyword, selectedTerms, client });
    };

    return (
        <>
            <NavButton
                onClick={handleClick}
                disabled={sendingPdf}>
                    {sendingPdf ? 'Sending pdf...' : 'Send Pdf'}
            </NavButton>
        </>
    );
};

export default SendSlidePdfButton;